var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"800px","value":true}},[_c('v-card',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('ItemGrid',{attrs:{"items":_vm.items}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('Order',{attrs:{"order":_vm.order}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }